/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class Template extends models.TemplateV2Base {
    getFixupPrototypeFunction() { return Template.fixupPrototype; }

    static newInstance(model: Partial<Template>): Template {
        let obj = Object.assign(new Template(), model);
        Template.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<Template>): Template {
        if (!model) return null;
        return Template.newInstance(<Template> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: Template) {
        if (!obj) return;

        models.Template.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: Template): boolean {
        if (models.TemplateV2Base.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, Template.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.params) {
            for (let val of this.params) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
        if (this.parameter_groups) {
            for (let val of this.parameter_groups) {
                models.TemplateParameterGroup.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique identifier of the template
     */
    template_id: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Whether the template is active or inactive
     */
    status: models.TemplateStatus;

    /**
     * Whether this is a temporary/draft template (used by Template Builder)
     */
    is_temp: boolean;

    /**
     * Materialized template body - resolved from git/file/url at read time
     */
    content: string;

    /**
     * User who created the template
     */
    created_by: string;

    /**
     * User who last updated the template
     */
    updated_by: string;

    /**
     * Template creation time in UTC
     */
    created_at: Date;

    /**
     * Template last update time in UTC
     */
    updated_at: Date;

    /**
     * Parameter schema (name, type, whether required, default value). Parsed once at create/update and persisted when content_type='file'; not populated for content_type='git'/'url', where the schema is resolved live via Get Params instead. Read-only - not accepted on create/update
     */
    params: Array<models.NamedParameter>;

    /**
     * Groups used to organize 'params' into UI form sections. Same persistence rule as 'params'. Read-only - not accepted on create/update
     */
    parameter_groups: Array<models.TemplateParameterGroup>;

}
